import { FunctionComponent } from 'react';
import Container from './container';
import Header from './header/header';
import Footer from './footer';

interface EmptyPageProps {
  title: string;
}

const EmptyPage: FunctionComponent<EmptyPageProps> = ({ title }) => {
  return (
    <div className='fixed left-0 top-0 w-full h-full flex flex-col'>
      <Header />
      <div className='flex-grow'>
        <Container className='pt-7'>{title}</Container>
      </div>
      <Footer />
    </div>
  );
};

export default EmptyPage;
